import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  previewHeader: {
    display: 'flex',
    marginBottom: '16px',
  },
  badge: {
    display: 'flex',
    backgroundColor: '#EBF3FC',
    height: '55px',
    padding: '16px 24px',
    border: '1px solid #B4D6FA',
    borderRadius: 9999,
    marginRight: '16px',
  },
  badgeIcon: {
    marginRight: '8px',
  },
  badgeText: {
    color: '#115EA3',
  },
});

export const AdChannelContainer = ({
  children,
  badgeText,
  onRenderBadgeIcon,
  onRenderChannelIcon,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classNames('ad-channel-container', classes.adChannelContainer)}>
      <div className={classes.previewHeader}>
        <div className={classes.badge}>
          <div className={classes.badgeIcon}>{onRenderBadgeIcon()}</div>
          <div className={classes.badgeText}>{i18n.getString(badgeText)}</div>
        </div>
        {onRenderChannelIcon()}
      </div>
      {children}
    </div>
  );
};

AdChannelContainer.propTypes = {
  children: PropTypes.node.isRequired,
  badgeText: PropTypes.string.isRequired,
  onRenderBadgeIcon: PropTypes.func.isRequired,
  onRenderChannelIcon: PropTypes.func.isRequired,
};
